function customerReducer(customer = null, action) {
  switch (action.type) {
    case "LOGIN":
      return action.payload;
    case "LOGOUT":
      return null;
    default:
      return customer;
  }
}

export default customerReducer;
